import { apiPost } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';

export const productConflictsApiAdapter = {
  checkProductConflicts: (data) => apiPost(DEALS_PATHS.checkProductConflicts, { data }),
};
